export default class AudioController {
  constructor(dumpAnaylsis, handleAudioEnd, updatePlaying){
    this.dumpAnalysis = dumpAnaylsis;
    this.handleAudioEnd = handleAudioEnd;
    this.updatePlaying = updatePlaying;

    this.animationRequest = null;
    this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    this.playing = false;

    this.unlock();
    this.prep();

    const bufferLength = this.analyser.frequencyBinCount;
    this.soundDataArray = new Uint8Array(bufferLength);
    this.audioBucketUrl = "https://d31dc3uk1vw0n5.cloudfront.net";
  }

  constructFileUrl = (fileName) => {
    fileName = fileName.replace(/ /g, '+').replace('?', '_');
    return `${this.audioBucketUrl}/${fileName}`;
  }

  prep = () => {
    this.soundSource = this.audioCtx.createBufferSource();
    this.soundSource.onended = this.end;

    this.analyser = this.audioCtx.createAnalyser();
    this.analyser.fftSize = 2048;
  }

  unlock = () => {
    let playBlankNoise = () =>  {
      // create empty buffer
      var buffer = this.audioCtx.createBuffer(1, 1, 22050);
      var source = this.audioCtx.createBufferSource();
      source.buffer = buffer;
      source.connect(this.audioCtx.destination);
      // play the file
      source.start ? source.start() : source.noteOn(0);
      window.removeEventListener('touchstart', playBlankNoise, false);
    }
    window.addEventListener('touchstart', playBlankNoise, false);
  }

  stop = () => {
    this.soundSource.stop()
  }

  end = () => {
    this.playing = false;
    this.updatePlaying(this.playing);
    this.endAnalysis();
    this.handleAudioEnd();
  }

  play = (fileName) => {
    this.playing = true;
    this.updatePlaying(this.playing);
    this.soundSource.start ? this.soundSource.start() : this.soundSource.noteOn(0);
    this.animationRequest = requestAnimationFrame(this.analyseAudio);
  }

  loadAudioData = (fileName) => {
    const url = this.constructFileUrl(fileName);

    if (this.playing) {
      this.soundSource.stop();
    }

    return fetch(url, {
      method: 'GET',
      responseType: 'arraybuffer'
    })
    .then(response => {
      return response.arrayBuffer();
    })
    .then(arrayBuffer => {
      return new Promise((res, rej) => {
        this.audioCtx.decodeAudioData(arrayBuffer, (audioBuffer) => {
          this.prep();
          this.soundSource.buffer = audioBuffer;
          this.soundSource.connect(this.analyser);
          this.analyser.connect(this.audioCtx.destination);
          res();
        })
      })
    })
  }

  analyseAudio = () => {
    this.analyser.getByteFrequencyData(this.soundDataArray);
    const soundSum = this.soundDataArray.reduce((acc, amplitude) => acc += amplitude);
    const avg = soundSum / this.analyser.frequencyBinCount;
    this.dumpAnalysis(avg);
    this.animationRequest = requestAnimationFrame(this.analyseAudio);
  }

  endAnalysis = () => {
    cancelAnimationFrame(this.animationRequest);
  }
}




// WEBPACK FOOTER //
// ./src/util/audio.js